import { render, staticRenderFns } from "./addFolderCompoment.vue?vue&type=template&id=7effcf66&scoped=true&"
import script from "./addFolderCompoment.vue?vue&type=script&lang=js&"
export * from "./addFolderCompoment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7effcf66",
  null
  
)

export default component.exports